import { useEffect, useState } from 'react';
import axios from 'axios';
import CandidateNavbar from '../Candidate Navbar/Navbar';
import { useNavigate } from "react-router-dom";
import DataTable  from 'react-data-table-component';
import LoadingSpinner from '../../Utils/LoadingSpinner'
import { toast } from 'react-toastify';
import Moment from 'react-moment';
export default function CandidateStatus(){
    const navigate = useNavigate();
    const [data,getData] = useState([]);
    const user = localStorage.getItem("user");
    const userId = user && JSON.parse(user)[0].id; 
    const [fristTime,setFristTime] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [loader,setLoader] = useState(true);
    
    useEffect(() => {
        const user = localStorage.getItem("user");
        if(user === null){
            localStorage.removeItem("user");
            navigate('/Candidate_Login');
        }
        else{
        axios.get(`https://pl.aspireitacademy.com/jbskr_status_list/${userId}`).then((res) => {
            if(res.data.length === 0){
                setFristTime(true)
                setLoader(false);
            }
            else{
                setFristTime(false)
                getData(res.data);
                setLoader(false);
            }
        }).catch(error => {
            toast.error("Something went wrong");
            setLoader(false);
          });

        }
    },[]);



    function dateConverter(dt){
	
        if(dt !== undefined && dt !== null ){
                 const parts = dt.split("-");
                 const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
                 return formattedDateOfBirth;
        }
        
    }








//Data table structure
const customStyles = {
    headRow: {
      style: {
        color:'#fff',
        backgroundColor: '#a7a7c1',
        fontSize:"13px"
      },
    },
    rows: {
      style: {
        color: "#000",
        backgroundColor: "#fff"
      }
    },
    // cells: {
    //     style: {
    //        margin: '0px', // override the cell padding for data cells
    //         paddingRight: '0px',
    //     },
    // },
    
  }

const columns = [
    {
        name: 'No',
        selector: row => row.no,
        width:"50px",
      
       
       
    },
    {
        name: 'Date',
        selector: row => row.date,
        sortable: true,
       
       
        
    },
    {
        name: 'Job Fair',
        selector: row => row.jobfair,
        sortable: true,
        grow:2,
       
        
    },
    {
        name: 'Company Name',
        selector: row => row.cmpname,
        sortable: true,
        grow:2,
       
    },
    {
        name: 'Job Description',
        selector: row => row.jobdesc,
        sortable: true,
        grow:2,
        
    },
    {
        name: 'Volunteer',
        selector: row => row.volunteer,
       
    },
    {
        name: 'Updated By',
        selector: row => row.updtby,
       
    },
    {
        name: 'Status',
        selector: row => row.status,
        center:true
      
       

    },
];


const rows = data?data.filter(
    item => item.CompanyName && item.CompanyName.toLowerCase().includes(filterText.toLowerCase()) ||
          item.jobfairID && item.jobfairID.toLowerCase().includes(filterText.toLowerCase()) ||
          item.status && item.status.toLowerCase().includes(filterText.toLowerCase()) || 
          item.description && item.description.toLowerCase().includes(filterText.toLowerCase())
).map((item,index) => {
    
   // let itemDate = dateConverter(item.date); // convert date format
    let itemDate =<Moment date={item.date}format="DD/MM/YYYY"  />// convert date format

    var colors;
    if (item.status === "Applied") { colors = { color: "green" } }
    if (item.status === "Rejected") { colors = { color: "red" } }
    if (item.status === "Shortlisted") { colors = { color: "#cdcd2f" } }
    if (item.status === "New" || item.volunteer === null || item.updated_by === null || item.date === null) {
        colors = { color: "gray" } 
        item.volunteer = "Not available...";
        item.updated_by = "Not available...";
        itemDate = "Not available..."
        }

    return {
        no : index+1 ,
        date:itemDate,
        jobfair:item.jobfairID,
        cmpname:item.CompanyName,
        jobdesc:item.description,
        volunteer:item.volunteer,
        updtby:item.updated_by,
        status:<span style={colors}>{item.status}</span>,
       
    }
}):''





    return(
        <section>
            <CandidateNavbar />
            { loader ? <LoadingSpinner />: 
            <div className="container">
                <h4 className='text-start text-capitalize mt-4 ps-2 page-title'>Job Status</h4>
               
                { fristTime ? 
                <div className="container">
                    <div className="card">
                        <div className="card-body text-center">
                            <h5 className="card-title">Welcome to Placement Plus</h5>
                            <h6 className="card-text" style={{ height: "50px" }}>Currently you are not applied for any companies</h6>
                            
                            <button type="button" onClick={() => {navigate('/Candidate_Dashboard')}} className="btn btn-primary" id='volsavebtn'> Apply Job</button>
                        </div>
                    </div>
                    </div>:

                <div className="table-responsive  px-1">
                        <div className='my-3 col-md-4 '>
                            <input type="search" 
                                className="form-control w-100  fs-6"
                                placeholder='Search'
                                onChange={(e)=>{setFilterText(e.target.value)}} 
                                value={filterText}/>
                                

                            
                            
                        </div>
                        <DataTable
                            
                            columns={columns}
                            data={rows} 
                            fixedHeader ={true} 
                            fixedHeaderScrollHeight="600px"
                            striped
                            customStyles={customStyles}  
                            persistTableHead
                            pagination
                            
                        />
                   
                </div>}
            </div>
}
            <br/>
        </section>
    )
}